import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import NewInquiryForm from "../Layouts/NewInquiryForm";
import { NewInquiryFormValues } from "../Add/AddNewInquiryFormWrapper";
import { showToast } from "src/utils/showToaster";
import { useUpdateContactMutation } from "src/services/ContactServices";

type Props = {
  onClose: () => void;
  queryData: any;
  InquiryId:any;
};

const EditNewInquiryFormWrapper = ({ onClose, queryData ,InquiryId }: Props) => { 

    const [updateQuery] = useUpdateContactMutation()

  // Form Initial Values
  const initialValues: NewInquiryFormValues = {
    name: queryData?.name || " ",
    mobile: queryData?.mobile || "",
    email: queryData?.email || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    mobile: string().required("Please enter mobile"),
    email: string().email(),
  });

  // Handle Submit
  const handleSubmit = (
    values: NewInquiryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<NewInquiryFormValues>
  ) => {
    updateQuery({
        id:InquiryId ,
        body : values
    }).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <NewInquiryForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Update"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditNewInquiryFormWrapper;
